<template lang="pug">
  .edit-modal
    .edit-field-modal
      .map-form
        GmapMap.custom-map(
          ref="mapRef"
          :center="center"
          :zoom="zoom"
          :tilt=0
          map-type-id="roadmap"
        )
        br
        button.toggle-legend-btn(@click="showLegend = !showLegend")
          | {{ showLegend ? '❌ Hide Legend' : 'ℹ️ Show Legend on map' }}
        .map-legend(v-if="showLegend")
          h4 How to Edit a Field Polygon
          ul
            li 🔵 Click on the map to place a pin (max 10)
            li 🟢 Drag a pin to reposition it
            li 🟥 Right-click a pin to remove it
            li 🔺 Marked area: your editable field polygon
            li 🔶 Other areas: other fields from the selected site
      .edit-form
        el-form(
          :model="form"
          ref="EditFieldForm"
          :rules="addFieldFormRules"
          @submit.native.prevent
        )
          el-row(:gutter="24")
            el-col(:span="12")
              el-form-item(
                prop="name"
                :label="$t('fields.actions.label.name')"
              )
                el-input(
                  v-model="form.name"
                  name="name"
                )
            el-col(:span="12")
              el-form-item(
                prop="site_id"
                :label="$t('fields.actions.label.site')"
              )
                el-select.w-100(
                  v-model='form.site_id'
                  filterable
                  allow-create
                  :placeholder="$t('fields.actions.label.site')"
                )
                  el-option(
                    v-for='site in sites'
                    :key='site.id'
                    :label='site.name'
                    :value='site.id'
                  )
          el-row(:gutter="24")
            el-col(:span="24")
              el-form-item(
                prop="name"
                :label="$t('fields.actions.label.color')"
              )
              color-picker-with-presets(v-model="color")
    el-row.text-center
      el-button.dark-green-btn.pop-up-btn(
        @click="handleUpdateField('EditFieldForm')"
        :loading="loading"
      ) {{ $t('common.edit') }}

</template>

<script>
import { gmapApi } from "vue2-google-maps";
import { mapActions, mapMutations, mapState } from "vuex";
import { customValidations } from "@utils/customValidators";
import { fieldsViewValidations } from "@utils/formValidations/fieldsViewValidations";
import { setObjectValues } from "@utils/generalUtils";
import ColorPickerWithPresets from "@components/_shared/ColorPickerWithPresets.vue";
import { getRomaniaCoordsIfLocationIsOff } from "@utils/map";

export default {
  name: "EditField",
  mixins: [fieldsViewValidations, customValidations],

  components: {
    'color-picker-with-presets': ColorPickerWithPresets,
  },

  data() {
    return {
      showLegend: true,
      zoom: 10,
      center: { lat: 0, lng: 0},
      marker: [],
      markers: [],

      form: {
        name: null,
        site_id: null
      },
      sites: [],
      fields: [],
      loading: false,

      color: { hex: '#00FF00' },

      fieldPolygons: [],
      fieldsListPolygons: [],

      setObjectValues,

    };
  },

  watch: {
    'form.site_id': {
      async handler(newValue, oldValue) {
        if (oldValue !== newValue) {
          await this.handleGetFields();
          this.drawFieldsListPolygons();
        }
      }
    },

    'color.hex'(newColor) {
      this.updatePolygonColor(newColor);
    }
  },

  computed: {
    google: gmapApi,

    ...mapState("auth", ["user"]),
    ...mapState("field", ["field"]),
  },

  async created() {
    await this.getBrowserLocation();
    await this.handleGetSites();
    
    this.handleGetFormData();
    await this.handleGetFields();
    this.drawFieldsListPolygons();
  },

  async mounted() {
    this.initializeFieldPolygon();
  },

  methods: {
    ...mapActions("site", ["getSites"]),
    ...mapActions('field', ['getFields', 'updateField']),
    ...mapMutations("dialog", ["hideEditFieldDialog"]),
    ...mapMutations("field", [
      "setField",
      "setShouldFetchFields",
    ]),

    handleGetFormData() {
      this.form = { ...this.field };
      this.form.site_id = this.field.site_id.toString();
      this.color = {
        hex: `#${this.field.color}`
      };
    },

    async handleGetSites() {
      const sites = await this.getSites("?page_size=1000");
      this.sites = sites.data;
    },

    async handleGetFields() {
      const fields = await this.getFields(`?page_size=1000&by_site_id=${this.form.site_id}`);
      this.fields = fields.data;
    },

    handleUpdateField(formName) {
      this.loading = true;
      const form = this.$refs[formName];

      form.validate(async (valid) => {
        if (valid) {
          const payload = {
            id: this.field.id,
            name: this.form.name,
            color: this.color.hex.replace('#', ''),
            site_id: this.form.site_id,
            field_coordinates: this.getFieldCoordinates()
          };

          this.updateField(payload)
            .then(() => {
              this.hideEditFieldDialog();
              this.clearForm();
              this.setShouldFetchFields(true);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.loading = false;
        }
      });
    },

    clearForm() {
      this.setObjectValues(this.form, "");
    },

    drawFieldsListPolygons() {
      var fieldsListPolygoneCoords = [];

      this.fieldsListPolygons.map((polygon) => polygon.setMap(null))
            
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.fields.forEach((field) => {
          if(field.id == this.field.id)
            return;
          fieldsListPolygoneCoords = [];
          field.field_coordinates.forEach( (field_coordinate) => {
            fieldsListPolygoneCoords.push({
              lat: Number(field_coordinate.latitude.toString()),
              lng: Number(field_coordinate.longitude.toString())
            })
          })

          var myPolygon = new google.maps.Polygon({
            paths: fieldsListPolygoneCoords,
            map: map,
            strokeColor: `#${field.color}`,
            strokeOpacity: 0.3,
            strokeWeight: 3,
            fillColor: `#${field.color}`,
            fillOpacity: 0.5,
            label: "yyyyy"
          });

          this.fieldsListPolygons.push(myPolygon)
        })
      });
    },

    async initializeFieldPolygon() {
      this.fieldPolygons.forEach(polygon => polygon.setMap(null));
      this.fieldPolygons = [];

      const map = await this.$refs.mapRef.$mapPromise;
      const vm = this;

      if (this.markers) {
        this.markers.forEach(marker => marker.setMap(null));
      }
      this.markers = [];

      const initialCoords = [];

      this.field.field_coordinates.forEach(coord => {
        const latLng = {
          lat: parseFloat(coord.latitude),
          lng: parseFloat(coord.longitude),
        };
        initialCoords.push(latLng);

        const marker = new google.maps.Marker({
          position: latLng,
          icon: this.pinSymbol("green"),
          map,
          draggable: true,
        });

        this.attachMarkerEvents(marker);
        this.markers.push(marker);
      });

      this.drawPolygon(initialCoords, map);

      google.maps.event.addListener(map, "click", (event) => {
        if (this.markers.length >= 10) {
          return this.$message({
            type: "warning",
            message: "Maximum 10 markers allowed.",
          });
        }

        const newMarker = new google.maps.Marker({
          position: event.latLng,
          icon: this.pinSymbol("blue"),
          map,
          draggable: true,
        });

        this.attachMarkerEvents(newMarker);
        this.markers.push(newMarker);
        this.updatePolygon();
      });
    },

    attachMarkerEvents(marker) {
      const vm = this;
      let clickTimeout = null;

      marker.addListener("dragend", () => {
        vm.updatePolygon();
      });

      marker.addListener("click", () => {
        if (clickTimeout !== null) return; // Ignore if waiting for dblclick

        clickTimeout = setTimeout(() => {
          const map = marker.getMap();
          if (map) {
            map.panTo(marker.getPosition());
            map.setZoom(18);
          }
          clickTimeout = null;
        }, 250); // Delay long enough to catch a dblclick
      });

      marker.addListener("rightclick", () => {
        if (vm.markers.length <= 3) {
          return this.$message({
            type: "error",
            message: "At least 3 points are required for a valid area.",
          });
        }

        marker.setMap(null);
        vm.markers = vm.markers.filter(m => m !== marker);
        vm.updatePolygon();
      });

      marker.addListener("dblclick", async () => {

        vm.markers.forEach(m => m.setMap(null));
        vm.markers = [];

        if (vm.fieldPolygons && vm.fieldPolygons.length) {
          vm.fieldPolygons.forEach(p => p.setMap(null));
          vm.fieldPolygons = [];
        }

        await vm.handleGetFields();

        vm.drawFieldsListPolygons();

        await vm.initializeFieldPolygon();
      });
    },

    drawPolygon(coords, map) {
      const polygon = new google.maps.Polygon({
        paths: coords,
        map: map,
        strokeColor: this.color.hex,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: this.color.hex,
        fillOpacity: 0.35,
      });

      this.fieldPolygons.push(polygon);
    },

    updatePolygon() {
      // Clear current polygons
      this.fieldPolygons.forEach(p => p.setMap(null));
      this.fieldPolygons = [];

      // Get current marker positions
      const updatedCoords = this.markers.map(marker => {
        const pos = marker.getPosition();
        return { lat: pos.lat(), lng: pos.lng() };
      });

      // Redraw polygon
      if (updatedCoords.length >= 3) {
        const map = this.markers[0].getMap();
        this.drawPolygon(updatedCoords, map);
      }
    },

    pinSymbol(color = "green") {
      return {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: color,
        fillOpacity: 1,
        strokeColor: '#000',
        strokeWeight: 2,
        scale: 8
      };
    },

    updatePolygonColor(newColor) {
      const hexColor = newColor;

      this.fieldPolygons.forEach(polygon => {
        polygon.setOptions({
          strokeColor: hexColor,
          fillColor: hexColor
        });
      });
    },

    getFieldCoordinates() {
      return this.markers.map(marker => {
        const pos = marker.getPosition();
        return {
          latitude: pos.lat(),
          longitude: pos.lng()
        };
      });
    },

    async getBrowserLocation() {
      if (this.field.field_coordinates) {
        this.center.lat = Number(this.field.field_coordinates[0].latitude);
        this.center.lng = Number(this.field.field_coordinates[0].longitude);
        this.zoom = 17;
      } else {
        navigator.geolocation.getCurrentPosition((location) => {
          this.center.lat = location.coords.latitude;
          this.center.lng = location.coords.longitude;
        });

        // if location is not working or turned off
        const romaniaCoords = await getRomaniaCoordsIfLocationIsOff()
        if (romaniaCoords) {
          this.center.lat = romaniaCoords.coords.latitude
          this.center.lng = romaniaCoords.coords.longitude
          this.zoom = 7
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@variables";

.edit-form {
  margin-left: 20px;
  .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
  }
}

.edit-field-modal {
  display: grid;
  grid-template-columns: 4fr 2fr;
  gap: 5px;
  // background-color: #2196F3;
  padding: 5px;
}

.map-legend {
  position: absolute;
  margin-top: -220px;
  left: 50px;
  max-width: 275px;
  background: white;
  border: 1px solid #ccc;
  padding: 8px 10px;
  font-size: 12px;
  z-index: 5;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  line-height: 1.4;
  word-wrap: break-word;
}

.map-legend h4 {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: bold;
}

.map-legend ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.map-legend li {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1.3;
}

.toggle-legend-btn {
  // position: absolute;
  // top: 10px;
  // right: 10px;
  z-index: 6;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 4px 8px;
  cursor: pointer;
}

.custom-map {
  width: 100% !important;
  // height: 60vh !important;
  height: 400px !important;
}
</style>
